<pp-icon
  [ppSrc]="icon"
  ppColor="grey-400"
  ppClass="setSize18"
  data-test="pp-padlock-icon"
  alt="padlock icon"
/>
